import { render, staticRenderFns } from "./editWidgetTableColumn.vue?vue&type=template&id=4ed1f564&"
import script from "./editWidgetTableColumn.vue?vue&type=script&lang=js&"
export * from "./editWidgetTableColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports